"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForm = void 0;
const useForm_1 = require("@reactionable/core/lib/form/useForm");
const Form_1 = require("./Form");
function useForm(props) {
    return useForm_1.useForm(Object.assign({ Component: Form_1.Form }, props));
}
exports.useForm = useForm;
//# sourceMappingURL=useForm.js.map